import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadCustomerInvoices = async () => {
  let response = await Axois.get('/invoices').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
}


export const loadCustomerInvoice = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/invoices');
        const responseData = await requests.data;
        return {...responseData, invoice: {}, entry: { }};
        // return {journals: [], accounts:[], entry:{}, transactions:[]};

      default:
        let response = await Axois.get('/invoices/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return {journals: [], accounts:[], entry:{}, transactions:[]};
    }
  }catch (err) {
    console.log(err);
  }
}


const useCustomerInvoiceAPI = () => {

  const save = async (data, success) => {
    try {
      const response = await Axois.post('/invoices', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('saved_invoice_response', {status: 'draft', number: responseData.number});
    }catch(err) {
      console.log(err);
    }
  };

  const postInvoice = async (number, data, success) => {
    try {
      const response = await Axois.patch('/invoices/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('invoice_posted', {status: 'posted', number: number});
    }catch (err) {
      if (err.response) {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }else {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }
    }
  }

  const update = async (number, data, success) => {
    try {
      const response = await Axois.put('/invoices/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      // EventEmitter.dispatch('saved_invoice_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      if (err.response) {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }else {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }
    }
  };

  const deleteRecord = async (number, success, navigate) => {
    try {
      const response = await Axois.put('/invoices/'+number);
      const responseData = await response.data;
      success(responseData.message);
      navigate(-1);
      // EventEmitter.dispatch('saved_invoice_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      if (err.response) {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }else {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }
    }
  };

  const saveCreditNote = async (data, success) => {
    try {
      const response = await Axois.post('/credit-notes', data);
      const responseData = await response.data;
      success(responseData.message);
      return responseData.number;
    }catch(err) {
      console.log(err);
    }
  };

  const createAndPost = async (data, success) => {
    try {
      const response = await Axois.post('/credit-notes/create-and-validate', data);
      const responseData = await response.data;
      success(responseData.message);
      return responseData.number;
    }catch (err) {
      if (err.response) {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }else {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }
    }
  }

  const resetToDraft = async (number, entry, success) => {
    try {
      const response = await Axois.patch('/invoices/reset-invoice/'+number.replaceAll('/', '-'), entry);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('invoice_reset', responseData.number);
    }catch (err) { 
      if (err.response) {
        EventEmitter.dispatch('invoice_error', err.response.data.message);
      }else {
        EventEmitter.dispatch('invoice_error', err);
      }
    }
  }

  return { save, update, postInvoice, deleteRecord, createAndPost, saveCreditNote, resetToDraft };
}


export default useCustomerInvoiceAPI;